import React, { Fragment } from 'react';
import { bool, number, string, shape } from 'prop-types';
import Head from 'next/head';
import AmpPrismEntryButton from 'components/AmpPrismEntryButton';
import ImageCaption from 'components/ImageCaption';
import { imageUrl } from 'util/images';

import styles from './styles';

function AmpImageSlider(props) {
  const { image1, image2, hasPrism } = props;

  const { caption, credit, hashedPublicId } = image2;

  const showCredit = caption || credit;
  const showPrism = hasPrism && hashedPublicId;
  const width = 1000;

  return (
    <Fragment>
      <Head>
        <script
          async
          custom-element="amp-image-slider"
          src="https://cdn.ampproject.org/v0/amp-image-slider-0.1.js"
          key="amp-image-slider"
        />
      </Head>
      <style jsx>{styles}</style>
      <div className="ImageSlider">
        <amp-image-slider
          className="ImageSlider__TriangleHint"
          width={image1.originalWidth}
          height={image1.originalHeight}
          layout="responsive"
        >
          <amp-img
            src={imageUrl(image1.url, { width })}
            alt={image1.alt}
            layout="fill"
          />
          <amp-img
            src={imageUrl(image2.url, { width })}
            alt={image2.alt}
            layout="fill"
          />
        </amp-image-slider>
        {(showCredit || showPrism) && (
          <div className="ImageSlider__info">
            {showCredit && (
              <ImageCaption
                credit={`${credit}${
                  image2.credit
                    ? `, ${image2.credit.replace('Credit: ', '')}`
                    : ''
                }`}
                caption={caption && caption.replace(credit, '').trim()}
              />
            )}
            {showPrism && <AmpPrismEntryButton imageId={hashedPublicId} />}
          </div>
        )}
      </div>
    </Fragment>
  );
}

const imageType = shape({
  url: string,
  alt: string,
  caption: string,
  href: string,
  isPinnable: bool,
  originalWidth: number,
  originalHeight: number
});

AmpImageSlider.defaultProps = {
  image1: {},
  image2: {},
  hasPrism: false
};

AmpImageSlider.propTypes = {
  image1: imageType,
  image2: imageType,
  hasPrism: bool
};

export default AmpImageSlider;
